/* eslint-disable */
import React from "react";

import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";

import RaindropDivider from "../../../ui-components/raindrop-divider/raindrop-divider";

import RaindropInput from "../../../ui-components/raindrop-input/raindrop-input.tsx";

import Spacer from "../../../ui-components/spacer/spacer";

import { useState } from "react";

import {
  fetchAuthenticationLogin,
  fetchGraphQL,
} from "../../../services/api-raindrop";
import { isLocalEnvironment } from "../../../services/environment.js";
import { RAINDROP_SESSION_TOKEN_KEY } from "../../../services/constants.js";
import { Link, useNavigate } from "react-router-dom";
import { Size } from "../../../logic/enums.ts";
import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import RaindropCardVerifyEmail from "../../../ui-components/raindrop-card-verify-email/raindrop-card-verify-email.tsx";
import RaindropTextParagraph from "../../../ui-components/raindrop-text-paragraph/raindrop-text-paragraph.tsx";
import RaindropTextHeading1 from "../../../ui-components/raindrop-text-heading-1/raindrop-text-heading-1.tsx";
import RaindropTextSubtitle from "../../../ui-components/raindrop-text-subtitle/raindrop-text-subtitle.tsx";
import RaindropCopyrightDeclaration from "../../../ui-components/raindrop-copyright-declaration/raindrop-copyright-declaration.js";
import RaindropTitle from "../../../ui-components/raindrop-title/raindrop-title.tsx";
import RaindropPage from "../../../ui-components/raindrop-page/raindrop-page.tsx";
import FlexCol from "../../../ui-components/flex-col/flex-col.tsx";

const ContentEmail = ({ email, setEmail }) => {
  return (
    <div className={"flex flex-col w-full gap-24 h-full justify-center"}>
      <RaindropInput
        id={"email-input"}
        placeholder="Email address"
        icon={null}
        value={email}
        isLarge={true}
        onChange={(e) => {
          setEmail(e.target.value);
        }}
        type="email"
      />
    </div>
  );
};

const DontHaveAnAccount = () => {
  return (
    <div className="flex flex-row gap-2 w-full items-center justify-center">
      <RaindropTextParagraph isFluid={false}>
        Don't have an account?
      </RaindropTextParagraph>
      <Link to="/raindrop/sign-up">
        <div className="font-black text-color-raindrop-primary text-lg">
          Sign up
        </div>
      </Link>
    </div>
  );
};

const LocalLoginHelper = () => {
  if (!isLocalEnvironment()) {
    return null;
  }
  return (
    <div className="flex flex-col gap-4 w-full justify-center items-center">
      <RaindropDivider />

      <div className="flex flex-row gap-4 w-full justify-center items-center">
        <RaindropButton
          title={"Barry Barren"}
          style={ButtonStyle.Secondary}
          isFluid={true}
          to={"/raindrop/authenticate?token=MAGIC_TOKEN_BARRY&onboarding=true"}
        />
        <RaindropButton
          title={"Warren Peace"}
          style={ButtonStyle.Secondary}
          isFluid={true}
          to={"/raindrop/authenticate?token=MAGIC_TOKEN_WARREN"}
        />
        <RaindropButton
          title={"Annie Malls"}
          style={ButtonStyle.Secondary}
          isFluid={true}
          to={"/raindrop/authenticate?token=MAGIC_TOKEN_ANNIE"}
        />
      </div>
    </div>
  );
};

const LoginWithPassword = () => {
  let navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const onSubmit = () => {
    setIsLoading(true);

    fetchGraphQL(`
        mutation {
          authenticateWithPassword(
            email: "${email}",
            password: "${password}"
          ) 
        }
      `)
      .then((response) => {
        if (!response?.data?.authenticateWithPassword) {
          console.log(response);
          setErrorMessage(response?.errors[0]?.message);
          setIsLoading(false);
          return;
        }
        const token = response?.data?.authenticateWithPassword;
        localStorage.setItem(RAINDROP_SESSION_TOKEN_KEY, token);
        navigate("/raindrop");
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="flex flex-col w-full justify-center items-center gap-4 max-w-md">
      <RaindropCard additionalClasses="gap-6">
        <div className="flex flex-col w-full ">
          <RaindropTextHeading1>Let's get you logged in</RaindropTextHeading1>

          <RaindropTextSubtitle>
            Enter your email and password
          </RaindropTextSubtitle>
        </div>
        <div className="flex flex-col gap-1 w-full">
          <RaindropInput
            placeholder="Email address"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
            autoComplete="email"
            name="username"
            type="text"
          />
          <RaindropInput
            placeholder="Password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            name="password"
            autoComplete="current-password"
            type="password"
            isPopulatingExampleIfLocal={true}
            errorMessage={errorMessage}
          />
        </div>
        <RaindropButton
          title="Login"
          onClick={onSubmit}
          size={Size.Large}
          isLoading={isLoading}
          isFluid={true}
          style={ButtonStyle.Primary}
        />
      </RaindropCard>
    </div>
  );
};

const LoginWithMagicLink = () => {
  const [inputEmail, setInputEmail] = useState("");

  const [hasSentMagicLink, setHasSentMagicLink] = useState(false);

  const [urlMagicLink, setUrlMagicLink] = useState();

  const [isLoading, setIsLoading] = useState(false);

  const onClickContinue = () => {
    setIsLoading(true);

    fetchAuthenticationLogin({
      email: inputEmail,
    })
      .then((data) => {
        setHasSentMagicLink(true);

        if (isLocalEnvironment()) {
          setUrlMagicLink(data?.url_magic_link);
        }
      })
      .catch((e) => {
        console.error(e);
        setIsLoading(false);
      });
  };

  if (hasSentMagicLink) {
    return (
      <RaindropCardVerifyEmail
        title="Check your email to login"
        inputEmail={inputEmail}
        localMagicLink={urlMagicLink}
      />
    );
  }

  return (
    <RaindropCard additionalClasses="max-w-md gap-6 ">
      <div className="flex flex-col w-full">
        <RaindropTextHeading1>Let's get you logged in</RaindropTextHeading1>

        <RaindropTextSubtitle>
          Enter your email to receive a magic link
        </RaindropTextSubtitle>
      </div>
      <RaindropInput
        placeholder="Email address"
        value={inputEmail}
        onChange={(e) => {
          setInputEmail(e.target.value);
        }}
        type="email"
      />

      <RaindropButton
        title="Continue"
        onClick={onClickContinue}
        style={ButtonStyle.Primary}
        isFluid={true}
        size={Size.Large}
        isLoading={isLoading}
      />
    </RaindropCard>
  );
};

const RaindropLogin = () => {
  const [isPasswordLogin, setIsPasswordLogin] = useState(true);

  return (
    <RaindropPage>
      {/* <div
        className={
          "flex flex-col  h-full py-8 px-4 gap-12 justify-center overflow-x-visible items-center w-full"
        }
      > */}
      <FlexCol className="max-w-md h-full">
        {/* <div className="flex flex-col max-w-2xl w-full gap-12 justify-center items-center"> */}
        <RaindropTitle
          style={ButtonStyle.Primary}
          size={Size.Large}
          isIncludingVersion={true}
        />

        {/* <Spacer /> */}
        <FlexCol className="h-full" tailwindGap="gap-4">
          {isPasswordLogin ? <LoginWithPassword /> : <LoginWithMagicLink />}

          <RaindropButton
            title={
              isPasswordLogin ? "Login with Magic Link" : "Login with password"
            }
            onClick={() => setIsPasswordLogin(!isPasswordLogin)}
            size={Size.Large}
            style={ButtonStyle.Secondary}
          />

          <DontHaveAnAccount />
        </FlexCol>

        <RaindropCopyrightDeclaration />

        {/* <Spacer /> */}

        <LocalLoginHelper />
        {/* </div> */}
      </FlexCol>
      {/* </div> */}
    </RaindropPage>
  );
};

export default RaindropLogin;
